import { useEffect, useState } from "react";

import { api } from "../api";

export function Events() {
  const [events, setEvents] = useState<Array<Record<string, unknown>>>();
  const [err, setErr] = useState("");
  useEffect(() => { api<{ events: Array<Record<string, unknown>> }>("/admin/events?limit=100").then((r) => setEvents(r.events)).catch((e: Error) => setErr(e.message)); }, []);
  if (err) return <div className="msg err">{err}</div>;
  if (!events) return <p className="chrome">Loading…</p>;
  return (
    <>
      <h2>Events</h2>
      <p className="sub">The last 100 raw analytics events, newest first. Kept 90 days.</p>
      <table className="tbl">
        <thead><tr><th>When</th><th>Type</th><th>Chain</th><th>Who</th><th>Props</th></tr></thead>
        <tbody>
          {events.map((e, i) => (
            <tr key={i}>
              <td className="chrome">{new Date(Number(e.ts)).toLocaleString()}</td>
              <td>{String(e.type)}</td>
              <td>{String(e.spreadId ?? "")}</td>
              <td className="chrome">{e.userId ? `user ${String(e.userId).slice(0, 8)}…` : `anon ${String(e.anonId ?? "").slice(0, 8)}`}</td>
              <td className="chrome">{e.props ? JSON.stringify(e.props) : ""}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}
